module.exports = __webpack_public_path__ + "static/media/Easilys.c5c60ab8.png";